<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: "Roboto-Regular", "NotoSansHans-Regular";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: url("./assets/img/bg-image.jpg");
  background-size: 100% 100%;
  text-align: center;
  color: #131313;
  padding: 0px;
  margin: 0px;
  width: 100%;
  height: 100%;
}

</style>



// WEBPACK FOOTER //
// src/App.vue